import { css as r } from "@microsoft/fast-element";
import { designTokens as l } from "../design-tokens.js";
import { typography as e } from "./typography.js";
const m = (o) => r`
  ${o} {
    /* Style */
    color: ${l.color.neutral[200]};
    /* Typography */
    ${e("label", "regular")}
  }
`;
export {
  m as labelStyles
};
